import React from 'react'

export default function Footer() {
  return (
    <footer className='footer'>
      <div className='d-flex justify-content-around'>
        <p className='text-muted'>Web development by Catherine Balogun</p>

        <a href="http://makeup-api.herokuapp.com/">Data provided by Makeup API</a>
      </div>
    </footer>
  )
}
